import { render, staticRenderFns } from "./BulkOrderCreate.vue?vue&type=template&id=3cdf045b&scoped=true&"
import script from "./BulkOrderCreate.vue?vue&type=script&lang=js&"
export * from "./BulkOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkOrderCreate.vue?vue&type=style&index=0&id=3cdf045b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdf045b",
  null
  
)

export default component.exports